import { OidcSession } from './oidc-config'

export const headersMyAtlas = (session?: OidcSession | null): any => ({
    'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_SEL_API_KEY,
    'Accept': 'application/json',
    'Authorization': `Bearer ${session?.accessToken}`,
    'Atlas-Context': 'compte'
})

export const headersPublic = (): any => {
    return {
        'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_SEL_PUBLIC_API_KEY,
        'Accept': 'application/json',
        'Atlas-Context': 'campus'
    }
}

export const headersCampus = (): any => {
    const headers: any = {
        'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_CAMPUS_API_KEY,
        'Accept': 'application/json',
    }
    return headers
}
